import { commerceOfferProperties } from "@/lib/analytics-ga4";
import { trackEvent } from "@/lib/analytics";

export function trackAgentRevenueOfferShown(props: {
  source_path?: string;
  intent?: string;
  offer_type: string;
  plan_id?: string;
  page_category?: string;
  placement?: string;
  checkout_channel?: string;
  commerce_system?: string;
  route_reason?: string;
  route_rank_score?: number;
  route_rank_reason?: string;
  ranked_offer_order?: string[];
  active_specialist?: string;
  specialist_reason?: string;
  agent_trace_id?: string;
  memory_signal?: string;
  customer_problem?: string;
  landing_intent?: string;
  detected_intent?: string;
  intent_confidence?: string;
  is_primary_cta?: boolean;
  cta_rank?: number;
  paywall_variant?: string;
  urgency?: string;
  confidence?: number;
  evidence?: string[];
  // Engine-detected personalization signals — were NULL on every offer impression
  // (2026-06-15 audit) so the per-dosha / per-band conversion of the recommendation
  // engine could not be attributed. Stamp them so the 1.81x engine-vs-shadow lift
  // is measurable by dosha + intent band. Already in the GA4 allowlist (analytics-ga4).
  strongest_dosha_id?: string;
  strongest_dosha_severity?: number;
  purchase_intent_band?: string;
}) {
  trackEvent("agent_revenue_offer_shown", props);
  trackEvent("commerce_offer_shown", commerceOfferProperties(props));
}

export function trackAgentDecisionMade(props: {
  agent_trace_id: string;
  session_id?: string;
  source_path?: string;
  intent?: string;
  customer_problem?: string;
  active_specialist?: string;
  specialist_reason?: string;
  route_reason?: string;
  memory_signal?: string;
  offer_type?: string;
  plan_id?: string;
  checkout_channel?: string;
  commerce_system?: string;
  route_rank_score?: number;
  route_rank_reason?: string;
  ranked_offer_order?: string[];
  tool_calls?: string[];
}) {
  trackEvent("agent_decision_made", props);
}

export function trackAgentRevenueOfferClicked(props: {
  source_path?: string;
  intent?: string;
  offer_type: string;
  plan_id?: string;
  page_category?: string;
  placement?: string;
  checkout_channel?: string;
  commerce_system?: string;
  route_reason?: string;
  route_rank_score?: number;
  route_rank_reason?: string;
  ranked_offer_order?: string[];
  agent_trace_id?: string;
  customer_problem?: string;
  landing_intent?: string;
  detected_intent?: string;
  intent_confidence?: string;
  is_primary_cta?: boolean;
  cta_rank?: number;
  paywall_variant?: string;
  strongest_dosha_id?: string;
  strongest_dosha_severity?: number;
  purchase_intent_band?: string;
}) {
  trackEvent("agent_revenue_offer_clicked", props);
  trackEvent("commerce_offer_clicked", commerceOfferProperties(props));
}

export function trackAgentRevenueOfferDismissed(props: {
  source_path?: string;
  intent?: string;
  offer_type: string;
  plan_id?: string;
  page_category?: string;
  placement?: string;
  checkout_channel?: string;
  commerce_system?: string;
  route_reason?: string;
  customer_problem?: string;
  urgency?: string;
  confidence?: number;
}) {
  trackEvent("agent_revenue_offer_dismissed", props);
}

export function trackShopifyProductClicked(props: {
  source_path?: string;
  intent?: string;
  page_category?: string;
  product_sku: string;
  product_name: string;
  triggered_by_dosha?: string | null;
  price_range?: string;
  placement: string;
  checkout_channel: "shopify_product";
  commerce_system: "shopify";
  customer_problem?: string;
  urgency?: string;
  confidence?: number;
}) {
  trackEvent("shopify_product_clicked", props);
  trackEvent(
    "commerce_offer_clicked",
    commerceOfferProperties({ ...props, offer_type: "product" })
  );
}

export function trackShopifyCartStarted(props: {
  source_path?: string;
  intent?: string;
  page_category?: string;
  product_skus: string[];
  product_count: number;
  placement: string;
  checkout_channel: "shopify_product";
  commerce_system: "shopify";
  customer_problem?: string;
  urgency?: string;
  confidence?: number;
}) {
  trackEvent("shopify_cart_started", props);
  trackEvent(
    "commerce_add_to_cart",
    commerceOfferProperties({ ...props, offer_type: "product_cart" })
  );
}
